export default {
  isDebugMode: state => state.isDebugMode === true,
  disabledUrl: state => state.disabledUrl,
  formData: state => state.formData,
  fileError: state => state.fileError,
  isFinished: state => state.isFinished,
  isSignMode: state => state.isSignMode,
  isSigned: state => state.isSigned,
  inputsToken: state => state.token,
}
